<template>
  <div class="loginPwd">
    <img src="@/assets/img/pic_banner.png" alt />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > 找回密码
    </div>
    <!-- <div class="nav_pos">
      <span class="text">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          v-for="(item, index) in $route.meta.breadUrl"
          :key="index"
        >
          <router-link v-if="item.url" :to="item.url">{{
            item.name
          }}</router-link>
          <a v-else>
            {{ item.name }}
          </a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>-->
    <div class="title">
      <span>找回密码</span>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="rule_form">
      <el-form-item label="验证方式：" prop="loginType" label-width="100px">
        <el-radio-group v-model="ruleForm.loginType" @change="fnChangeLoginType">
          <el-radio label="0">普通登录</el-radio>
          <el-radio label="1">供应商CA证书登录</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="社会信用代码：" prop="loginName" label-width="150px" v-if="ruleForm.loginType == '0'">
        <el-input v-model="ruleForm.loginName" placeholder="请输入公司社会信用代码"></el-input>
      </el-form-item>
      <el-form-item label="手机号码：" prop="mobile" label-width="150px" v-if="ruleForm.loginType == '0'">
        <el-input v-model="ruleForm.mobile" placeholder="请输入手机号码后，获取验证码"></el-input>
        <div class="msg_code" @click.stop="getCode()" :class="{ disabled }">{{ codeName }}</div>
      </el-form-item>
      <el-form-item label="短信验证码：" prop="authCode" label-width="150px" v-if="ruleForm.loginType == '0'">
        <el-input v-model="ruleForm.authCode" placeholder="请输入手机验证码"></el-input>
      </el-form-item>
      <el-form-item label="CA证书：" label-width="150px" v-if="ruleForm.loginType == '1'">
        <el-input v-model="ruleForm.CAname" readonly="readonly"></el-input>
      </el-form-item>
      <el-form-item label="证书密码：" label-width="150px" v-if="ruleForm.loginType == '1'">
        <el-input placeholder="请输入证书密码" v-model="ruleForm.CApwd" show-password type="password" @change="loginEvents"></el-input>
      </el-form-item>

      <el-form-item label="设置新密码：" prop="loginPwd" label-width="150px">
        <el-input type="password" show-password v-model="ruleForm.loginPwd" placeholder="请输入您的新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码：" prop="reLoginPwd" label-width="150px">
        <el-input type="password" show-password v-model="ruleForm.reLoginPwd" placeholder="请确认您的新密码"></el-input>
      </el-form-item>
    </el-form>
    <div style="text-align: center">
      忘记手机号码？
      <el-link :underline="false" @click.stop="fnResetPhone()">重置手机号码</el-link>
    </div>
    <div class="btn_1" @click="submit()">提交</div>
  </div>
</template>

<script>
import { validatePass, validatePass2, validatemobile1 } from '@/assets/js/util'
import jsSHA from '@/assets/js/sha.js'
export default {
  data() {
    return {
      submited: false,
      random: '',
      randomSign: '',
      certification: '',
      ruleForm: {
        loginType: '0',
        CAname: '',
        CApwd: '',
        CertId: '',
        loginName: '',
        mobile: '',
        authCode: '',
        loginPwd: '',
        reLoginPwd: '',
        sysNo: ''
        //  accountId:""
      },
      codeName: '短信获取验证码',
      disabled: false,
      rules: {
        loginType: [{ required: true, message: '请选择验证方式', trigger: 'blur' }],
        loginName: [{ required: true, message: '请输入公司社会信用代码', trigger: 'blur' }],
        authCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        loginPwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
        reLoginPwd: [{ required: true, validator: validatePass2, trigger: 'blur' }],
        mobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }]
      }
    }
  },
  methods: {
    back() {
      this.$router.push('/')
    },
    getCode() {
      if (!this.ruleForm.loginName) {
        this.$message.error('请输入公司社会信用代码')
        return
      }
      if (!this.ruleForm.mobile) {
        this.$message.error('请输入手机号码')
        return
      }
      if (!this.disabled) {
        this.postRequest('SupplierLogin/SendValidateCode4ResetLoginPwd', {
          mobile: this.ruleForm.mobile,
          loginName: this.ruleForm.loginName
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.ruleForm.accountId = res.data.accountId

            localStorage.setItem('loginToken1', res.data.loginToken)
            let time = 60
            let timer = setInterval(() => {
              this.disabled = true
              if (time == 0) {
                this.codeName = '短信获取验证码'
                clearInterval(timer)
                this.disabled = false
              } else {
                this.codeName = '重新发送(' + time + ')'
                time--
              }
            }, 1000)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    submit() {
      var that = this
      if (!that.submited) {
        that.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (that.ruleForm.loginType == '1' && (that.ruleForm.sysNo == '' || that.ruleForm.sysNo == null)) {
              this.$message.error('CA登录验证未通过')
            }
            this.save()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    },
    save() {
      let stoken = window.localStorage.getItem('loginToken1')
      localStorage.setItem('loginToken', stoken)
      var shaObj = new jsSHA(this.ruleForm.loginPwd, 'TEXT')
      this.ruleForm.loginPwd = shaObj.getHash('SHA-1', 'HEX')
      let config = {
        dataJson: JSON.stringify(this.ruleForm)
      }
      this.postRequest('/SupplierLogin/SaveResetLoginPwd', config)
        .then((res) => {
          var data = res.data
          window.localStorage.removeItem('loginToken')
          window.localStorage.removeItem('loginToken1')
          if (data.errcode == 0) {
            this.$message({ message: '密码修改成功！', type: 'success' })
            that.submited = true //不可重复提交
            this.$router.push('/')
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnChangeLoginType(value) {
      window.console.log(value)
      if (value == 1) {
        window.console.log('定时服务启动')
        this.fnUpdateCA()
        this.timer = setTimeout(this.fnUpdateCA, 5000)
      } else {
        window.console.log('定时服务停止')
        clearTimeout(this.timer)
      }
    },
    fnUpdateCA() {
      window.console.log('定时服务开始执行')
      window.SOF_GetUserList((data) => {
        var UserListStr = data.retVal
        // window.console.log(data.retVal);
        var arr = UserListStr.split('&&&')
        // this.certs = new Array();
        this.ruleForm.CAname = arr[0].split('||')[0]
        this.ruleForm.CertId = arr[0].split('/')[1]
        // for (var index = 0; index < arr.length; index++) {
        //   var Belong = arr[index].split("||")[0]; //电子合同个人测试6||998000100204344/5303201807021399(证书所有者||密码卡序列号/USB-key序列号)
        //   var u_key = arr[index].split("/")[1];
        //   var obj = {};
        //   obj.text = Belong;
        //   obj.value = u_key;
        //   this.certs.push(obj);
        // }
        // clearTimeout(this.timer);
        return
      })

      this.timer = setTimeout(this.fnUpdateCA, 5000)
    },
    loginEvents() {
      let pwdValidate = false
      this.getRequest('/SupplierLogin/GetCAInfo').then((res) => {
        if (res.data.errcode == 0) {
          this.random = res.data.Random //随机数
          this.randomSign = res.data.RandomSign //随机数标识
          this.certification = res.data.Certification //证书

          //6、用户输入密码，应用系统验证口令
          window.SOF_Login(this.ruleForm.CertId, this.ruleForm.CApwd, (data) => {
            if (data.retVal) {
              pwdValidate = true
            } else {
              pwdValidate = false
            }
            // else {
            //   this.$message({ type: "fail", message: "登录密码错误!" });
            // }
            window.SOF_VerifySignedData(
              //验证服务器端随机数签名值
              this.certification,
              this.random,
              this.randomSign,
              (data) => {
                if (data.retVal) {
                  //验证服务器证书有效性
                  window.SOF_ValidateCert(this.certification, (data) => {
                    if (data.retVal == 0) {
                      //应用系统调用XTX服务队随机数进行签名
                      //1、导出用户证书
                      window.SOF_ExportUserCert(this.ruleForm.CertId, (data) => {
                        var UserCert = data.retVal

                        window.SOF_GetCertEntity(UserCert, (data) => {
                          var identification = data.retVal
                          //2、数字签名
                          window.SOF_SignData(this.ruleForm.CertId, this.random, (data) => {
                            var NumSign = data.retVal

                            let config = {
                              params: {
                                strCert: UserCert,
                                random: this.random,
                                signVal: NumSign,
                                certId: this.CertId,
                                CartCode: identification,
                                pwdValidate: pwdValidate
                              }
                            }
                            this.getRequest('/SupplierLogin/CALoginVerify', config).then((res) => {
                              if (res.data.errcode == 0) {
                                this.ruleForm.sysNo = res.data.sysNo
                                //获取用户唯一标识
                              } else {
                                this.$message.error(res.data.errmsg)
                              }
                            })
                          })
                        })
                      })
                    } else {
                      switch (data.retVal) {
                        case -1:
                          this.$message.error('服务器证书出错：证书不被信任')
                          break
                        case -2:
                          this.$message.error('服务器证书出错：超过有效期范围')
                          break
                        case -3:
                          this.$message.error('服务器证书出错：证书已作废')
                          break
                        case -4:
                          this.$message.error('服务器证书出错：证书已冻结')
                          break
                        case -5:
                          this.$message.error('服务器证书出错：证书未生效')
                          break
                        case -6:
                          this.$message.error('服务器证书出错：其他错误')
                          break
                      }
                    }
                  })
                } else {
                  this.$message({ type: 'fail', message: '安全验证未通过!' })
                }
              }
            )
          })
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnResetPhone() {
      this.$router.push('/resetphone')
    }
  }
}
</script>

<style lang="scss" scoped>
.loginPwd {
  margin-bottom: 100px;
  .title {
    position: relative;
    padding-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #0774c5;
    span {
      padding: 6px 40px;
      font-weight: bold;
      font-size: 16px;
      color: #0774c5;
      text-align: center;
      border-bottom: 2px solid #0774c5;
    }
    .back_btn {
      bottom: 6px;
    }
  }
  .btn_1 {
    font-weight: bold;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 25px;
    width: 160px;
  }
  .disabled {
    background: #ccc;
  }
}
</style>
